module.exports = __webpack_public_path__ + "static/img/wxts.b3ef2a88.jpg";